<template>
  <div class="my-card">
    <swiper :options="swiperOption">
      <swiperSlide v-for="(card, index) in products" :key="'card' + index">
        <div class="my-card-link" @click.stop="LinkProduct(card.id)">
          <div class="img-box">
            <img
              :src="JSON.parse(card.banner)[0]"
              v-if="JSON.parse(card.banner)[0]"
              class="seipImg"
              v-load="'oProSmall'"
            />
            <div class="img-v" v-if="card.panoramaUrl">
              <i class="iconfont icon-VR1"></i>
            </div>
            <!-- <div
              class="play_video"
              v-if="card.video && JSON.parse(card.video).url"
            >
              <i class="iconfont icon-zhibo"></i>
            </div> -->
          </div>
        </div>
      </swiperSlide>
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { mapActions } from "vuex";
export default {
  name: "swiperCard",
  props: ["products"],
  data() {
    return {
      swiperOption: {
        slidesPerView: 3.8,
        autoplay: false,
        spaceBetween: 7,
      },
    };
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  created() {},
  methods: {
    ...mapActions({
      LinkProduct: "linkTo/LinkProduct",
    }),
    parseBanner: function (data) {
      let banner = "";
      if (data.search(/^\[/) !== -1) {
        banner = JSON.parse(data)[0];
      } else {
        banner = [data];
      }
      return banner;
    },
  },
};
</script>
 
<style scoped lang="scss">
.my-card {
  width: 100%;
  margin: 0.2rem auto 0;
  p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 1.5;
    padding-top: 8px;
    padding-bottom: 12px;
    text-align: center;
  }
}
.swiper-slide {
  .my-card-link {
    display: block;
    width: 100%;
  }
  .img-box {
    height: 0;
    padding-bottom: 100%;
    position: relative;
    width: 100%;
    border-radius: 2.5px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      position: absolute;
    }
    .img-v {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
      color: #0190fe;
      width: 0.38rem;
      border: 1px solid #0190fe;
      display: flex;
      align-content: center;
      justify-content: center;
      background-color: #fff;
    }
    .play_video {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.2);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 2;
      i {
        font-size: 0.72rem;
        color: #fff;
      }
    }
  }
}
</style> 